module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-section",
    class: {
      'is-collapsed': _vm.isCollapsed
    }
  }, [_c('div', {
    staticClass: "rt-section__header"
  }, [_c('span', {
    on: {
      "click": _vm.handleClick
    }
  }, [_c('i', {
    staticClass: "rt-section__header__arrow el-icon-arrow-down"
  }), _vm._v("\n            " + _vm._s(_vm.title) + "\n        ")]), _vm._v(" "), (!_vm.isCollapsed) ? _c('rt-toolbar', [_vm._t("toolbar")], 2) : _vm._e()], 1), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isCollapsed),
      expression: "!isCollapsed"
    }],
    staticClass: "rt-section__content"
  }, [_vm._t("default")], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-633ecd1b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/section/src/main.vue
// module id = 689
// module chunks = 220